module.exports = __webpack_public_path__ + "b4077486171b497f0fe3862833a0c71d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/promo/ts_gowrostermania.jpg
// module id = 1040
// module chunks = 0